import { computed, ref } from "vue";
import { ApiRepository } from "@/repositories/ApiRepository";

export const FetchTokenChecking = (queryParams: any) => {
  // 토큰 검증
  const apiRepository = new ApiRepository();
  const tokenCheckingRepository = computed(() => apiRepository);

  const response = ref<any>({});

  // 비동기 처리로 변경
  tokenCheckingRepository.value
    .get("common/check-token-valid", queryParams)
    .then(result => {
      response.value = result;
    })
    .catch(error => {
      response.value = { status: 401 };
    });

  return {
    response,
  };
};
